/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';

import type { IBaseResponse, IDateRange } from '@home/types/common';
import type { IProjectSimpleDTO } from '@gp/types/global';
import type { IDPSReportType } from '@gp/types/dpsReport/common';
import type {
  IDPSReportDTOV2,
  IDPSReportSpecialDTO,
  ICommonProjectMilestoneDTOV2,
  ICalendarProjectMilestoneDTOV2,
  IChangesProjectMilestoneDTOV2,
  IDPSReportEditParamsV2,
} from '@gp/types/dpsReport/v2';

interface IDPSReportActionBaseParams {
  type: IDPSReportType;
  id: string;
  report_id: string;
}

/**
 * 获取DPS周报详情数据
 * @param params 参数对象
 * @param params.start_date DPS周报的开始时间
 * @param params.end_date DPS周报的结束时间
 * @param params.type DPS周报类型
 * @param params.id DPS周报的id
 * @returns DPS周报详情数据
 */
export const fetchDPSReportDetails = async (
  params: IDPSReportActionBaseParams & {
    start_date: string;
    end_date: string;
  },
): IBaseResponse<IDPSReportDTOV2 | null> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/weekly_reportV2',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};

/**
 * 获取DPS周报初始化数据（新增周报时调用）
 * @param params 参数对象
 * @param params.start_date 开始日期
 * @param params.end_date 结束日期
 * @returns DPS周报初始化数据
 */
export const fetchDPSReportInitialData = async (params: IDateRange): IBaseResponse<IDPSReportSpecialDTO> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/edit_report_init',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

/**
 * 获取dps周报新增、编辑时，可选的全量project数据
 * @returns 全量project数据
 */
export const fetchFullyProjects = async (): IBaseResponse<{
  list: IProjectSimpleDTO[] | null;
}> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/project_list',
    method: 'GET',
    params: {},
    rawData: true,
  }) as any;
};

export const fetchCommonProjectsMilestones = async (
  params: IDateRange,
): IBaseResponse<{
  hightlights: ICommonProjectMilestoneDTOV2[] | null;
  calendar: ICalendarProjectMilestoneDTOV2[] | null;
}> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/milestone_add',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

export const fetchChangesProjectsMilestones = async (
  params: IDateRange,
): IBaseResponse<{
  changes: IChangesProjectMilestoneDTOV2[] | null;
}> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/milestone_change_add',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

/**
 * 编辑DPS周报，新增、编辑同一个接口
 */
export const editDPSReport = (params: IDPSReportEditParamsV2): IBaseResponse<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/dps_report/edit_report',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};
